import { __read, __spread } from "tslib";
export var TaskCodes;
(function (TaskCodes) {
    TaskCodes["PHOTO"] = "Photo";
    TaskCodes["PHONE"] = "Phone";
    TaskCodes["VIDEO"] = "Video";
    TaskCodes["CONSENT"] = "Consent";
    TaskCodes["PAYMENT"] = "Payment";
    TaskCodes["DELIVERY"] = "Delivery";
    TaskCodes["QUESTIONNAIRE"] = "Questionnaire";
    TaskCodes["MEDICAL_HISTORY"] = "Medical-History";
})(TaskCodes || (TaskCodes = {}));
export var TaskStatuses;
(function (TaskStatuses) {
    TaskStatuses["OPEN"] = "open";
    TaskStatuses["PENDING"] = "pending";
    TaskStatuses["UPLOADED"] = "uploaded";
    TaskStatuses["REJECTED"] = "rejected";
    TaskStatuses["APPROVED"] = "approved";
    TaskStatuses["COMPLETE"] = "complete";
    TaskStatuses["CANCELLED"] = "cancelled";
})(TaskStatuses || (TaskStatuses = {}));
export var VisitStatuses;
(function (VisitStatuses) {
    VisitStatuses["CANCELLED"] = "cancelled";
    VisitStatuses["ABANDONED"] = "abandoned";
    VisitStatuses["PRE_VISIT_INTAKE"] = "pre_visit_intake";
    VisitStatuses["SIGNED_AND_CLOSED"] = "signed_and_closed";
    VisitStatuses["READY_FOR_PROVIDER"] = "ready_for_provider";
})(VisitStatuses || (VisitStatuses = {}));
export var OPEN_VISIT_STATUSES = [VisitStatuses.PRE_VISIT_INTAKE, VisitStatuses.READY_FOR_PROVIDER];
export var CLOSED_VISIT_STATUSES = [
    VisitStatuses.CANCELLED,
    VisitStatuses.ABANDONED,
    VisitStatuses.SIGNED_AND_CLOSED,
];
export var COMPLETE_VISIT_STATUSES = __spread(CLOSED_VISIT_STATUSES, [VisitStatuses.READY_FOR_PROVIDER]);
export var MessageTypes;
(function (MessageTypes) {
    MessageTypes["NPS"] = "nps";
    MessageTypes["DEFAULT"] = "default";
    MessageTypes["RETAKE_PHOTOS"] = "retake_photos";
    MessageTypes["TREATMENT_PLAN"] = "treatment_plan";
    MessageTypes["START_VISIT"] = "start_visit";
    MessageTypes["PRESCRIPTION"] = "prescription";
    MessageTypes["EDUCATION"] = "education";
    MessageTypes["PHONE_CALL_BACK"] = "phone_call_back";
    MessageTypes["REQUEST_PHOTO"] = "request_photo";
    MessageTypes["PHOTO_UPLOAD"] = "photo_upload";
})(MessageTypes || (MessageTypes = {}));
export var UserNotificationTopics;
(function (UserNotificationTopics) {
    UserNotificationTopics["NEW_MESSAGES"] = "new_messages";
    UserNotificationTopics["GOODRX_DISCOUNTS"] = "goodrx_discounts";
})(UserNotificationTopics || (UserNotificationTopics = {}));
export var UserNotificationChannels;
(function (UserNotificationChannels) {
    UserNotificationChannels["SMS"] = "sms";
    UserNotificationChannels["PUSH"] = "push";
    UserNotificationChannels["EMAIL"] = "email";
    UserNotificationChannels["IN_APP"] = "in_app";
})(UserNotificationChannels || (UserNotificationChannels = {}));
export var LegalCodes;
(function (LegalCodes) {
    LegalCodes["PrivacyPolicy"] = "privacy-policy";
    LegalCodes["TermsAndConditions"] = "terms-and-conditions";
    LegalCodes["NoticeOfPrivacyPractices"] = "notice-of-privacy-practices";
    LegalCodes["ConsentToTelemedicine"] = "consent-to-telemedicine";
    LegalCodes["AgreementForSelfPaymentOfServices"] = "agreement-for-self-payment-of-services";
    LegalCodes["HIPAAMarketingAuthorization"] = "hipaa-marketing-authorization";
})(LegalCodes || (LegalCodes = {}));
export var PrescriptionStatuses;
(function (PrescriptionStatuses) {
    PrescriptionStatuses["SENT"] = "sent";
    PrescriptionStatuses["WRITTEN"] = "written";
    PrescriptionStatuses["TRANSMITTING"] = "transmitting";
    PrescriptionStatuses["ERROR_PHARMACY"] = "error_pharmacy";
    PrescriptionStatuses["READY_TO_TRANSMIT"] = "ready_to_transmit";
    PrescriptionStatuses["ERROR_CLEARINGHOUSE"] = "error_clearinghouse";
    PrescriptionStatuses["ABANDONED"] = "abandoned";
})(PrescriptionStatuses || (PrescriptionStatuses = {}));
export var STAFF_USER_INACTIVITY_LIMIT_MS = 1800000;
export var DispenseUnits = [
    {
        DispenseUnitId: 1,
        Name: 'Bag',
        Abbreviation: 'BG',
        Singular: 'Bag',
        Plural: 'Bags',
        SingularOrPlural: 'Bag(s)',
        PotencyUnitCode: 'C48474',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 2,
        Name: 'Bottle',
        Abbreviation: 'BO',
        Singular: 'Bottle',
        Plural: 'Bottles',
        SingularOrPlural: 'Bottle(s)',
        PotencyUnitCode: 'C48477',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 3,
        Name: 'Box',
        Abbreviation: 'BX',
        Singular: 'Box',
        Plural: 'Boxes',
        SingularOrPlural: 'Box(es)',
        PotencyUnitCode: 'C48478',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 4,
        Name: 'Capsule',
        Abbreviation: 'AV',
        Singular: 'Capsule',
        Plural: 'Capsules',
        SingularOrPlural: 'Capsule(s)',
        PotencyUnitCode: 'C48480',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 5,
        Name: 'Cartridge',
        Abbreviation: 'CQ',
        Singular: 'Cartridge',
        Plural: 'Cartridges',
        SingularOrPlural: 'Cartridge(s)',
        PotencyUnitCode: 'C48481',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 6,
        Name: 'Container',
        Abbreviation: 'CH',
        Singular: 'Container',
        Plural: 'Containers',
        SingularOrPlural: 'Container(s)',
        PotencyUnitCode: 'C48484',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 7,
        Name: 'Metric Drop',
        Abbreviation: 'X4',
        Singular: 'Metric Drop',
        Plural: 'Metric Drops',
        SingularOrPlural: 'Metric Drop(s)',
        PotencyUnitCode: 'C48491',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 8,
        Name: 'Gram',
        Abbreviation: 'GR',
        Singular: 'Gram',
        Plural: 'Grams',
        SingularOrPlural: 'Gram(s)',
        PotencyUnitCode: 'C48155',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 9,
        Name: 'Inhaler',
        Abbreviation: 'IH',
        Singular: 'Inhaler',
        Plural: 'Inhalers',
        SingularOrPlural: 'Inhaler(s)',
        PotencyUnitCode: 'C62275',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 10,
        Name: 'International',
        Abbreviation: 'F2',
        Singular: 'International',
        Plural: 'International',
        SingularOrPlural: 'International',
        PotencyUnitCode: null,
        IsActive: false,
        Result: null,
    },
    {
        DispenseUnitId: 11,
        Name: 'Kit',
        Abbreviation: 'KT',
        Singular: 'Kit',
        Plural: 'Kits',
        SingularOrPlural: 'Kit(s)',
        PotencyUnitCode: 'C48504',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 12,
        Name: 'Liter',
        Abbreviation: 'LT',
        Singular: 'Liter',
        Plural: 'Liters',
        SingularOrPlural: 'Liter(s)',
        PotencyUnitCode: 'C48505',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 13,
        Name: 'Lozenge',
        Abbreviation: 'UU',
        Singular: 'Lozenge',
        Plural: 'Lozenges',
        SingularOrPlural: 'Lozenge(s)',
        PotencyUnitCode: 'C48506',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 14,
        Name: 'Milligram',
        Abbreviation: 'ME',
        Singular: 'Milligram',
        Plural: 'Milligrams',
        SingularOrPlural: 'Milligram(s)',
        PotencyUnitCode: 'C28253',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 15,
        Name: 'Milliliter',
        Abbreviation: 'ML',
        Singular: 'Milliliter',
        Plural: 'Milliliters',
        SingularOrPlural: 'Milliliter(s)',
        PotencyUnitCode: 'C28254',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 16,
        Name: 'Million Units',
        Abbreviation: 'UM',
        Singular: 'Million Units',
        Plural: 'Million Units',
        SingularOrPlural: 'Million Units',
        PotencyUnitCode: null,
        IsActive: false,
        Result: null,
    },
    {
        DispenseUnitId: 17,
        Name: 'Mutually Defined',
        Abbreviation: 'ZZ',
        Singular: 'Mutually Defined',
        Plural: 'Mutually Defined',
        SingularOrPlural: 'Mutually Defined',
        PotencyUnitCode: null,
        IsActive: false,
        Result: null,
    },
    {
        DispenseUnitId: 18,
        Name: 'Fluid Ounce',
        Abbreviation: 'FO',
        Singular: 'Fluid Ounce',
        Plural: 'Fluid Ounces',
        SingularOrPlural: 'Fluid Ounce(s)',
        PotencyUnitCode: 'C48494',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 19,
        Name: 'Unspecified',
        Abbreviation: '00',
        Singular: 'Unspecified',
        Plural: 'Unspecified',
        SingularOrPlural: 'Unspecified',
        PotencyUnitCode: 'C38046',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 20,
        Name: 'Package',
        Abbreviation: 'PH',
        Singular: 'Package',
        Plural: 'Packages',
        SingularOrPlural: 'Package(s)',
        PotencyUnitCode: 'C48520',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 21,
        Name: 'Packet',
        Abbreviation: '12',
        Singular: 'Packet',
        Plural: 'Packets',
        SingularOrPlural: 'Packet(s)',
        PotencyUnitCode: 'C48521',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 22,
        Name: 'Pint',
        Abbreviation: 'PT',
        Singular: 'Pint',
        Plural: 'Pints',
        SingularOrPlural: 'Pint(s)',
        PotencyUnitCode: 'C48529',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 23,
        Name: 'Suppository',
        Abbreviation: 'AR',
        Singular: 'Suppository',
        Plural: 'Suppositories',
        SingularOrPlural: 'Suppositories',
        PotencyUnitCode: 'C48539',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 24,
        Name: 'Syringe',
        Abbreviation: 'SZ',
        Singular: 'Syringe',
        Plural: 'Syringes',
        SingularOrPlural: 'Syringe(s)',
        PotencyUnitCode: 'C48540',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 25,
        Name: 'Tablespoon',
        Abbreviation: 'Y2',
        Singular: 'Tablespoon',
        Plural: 'Tablespoons',
        SingularOrPlural: 'Tablespoon(s)',
        PotencyUnitCode: 'C48541',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 26,
        Name: 'Tablet',
        Abbreviation: 'U2',
        Singular: 'Tablet',
        Plural: 'Tablets',
        SingularOrPlural: 'Tablet(s)',
        PotencyUnitCode: 'C48542',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 27,
        Name: 'Teaspoon',
        Abbreviation: 'Y3',
        Singular: 'Teaspoon',
        Plural: 'Teaspoons',
        SingularOrPlural: 'Teaspoon(s)',
        PotencyUnitCode: 'C48544',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 28,
        Name: 'Patch',
        Abbreviation: 'FG',
        Singular: 'Patch',
        Plural: 'Patches',
        SingularOrPlural: 'Patches',
        PotencyUnitCode: 'C48524',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 29,
        Name: 'Tube',
        Abbreviation: 'TB',
        Singular: 'Tube',
        Plural: 'Tubes',
        SingularOrPlural: 'Tube(s)',
        PotencyUnitCode: 'C48549',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 30,
        Name: 'Unit',
        Abbreviation: 'UN',
        Singular: 'Unit',
        Plural: 'Units',
        SingularOrPlural: 'Unit(s)',
        PotencyUnitCode: null,
        IsActive: false,
        Result: null,
    },
    {
        DispenseUnitId: 31,
        Name: 'Vial',
        Abbreviation: 'VI',
        Singular: 'Vial',
        Plural: 'Vials',
        SingularOrPlural: 'Vial(s)',
        PotencyUnitCode: 'C48551',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 32,
        Name: 'Each',
        Abbreviation: 'EA',
        Singular: 'Each',
        Plural: 'Each',
        SingularOrPlural: 'Each',
        PotencyUnitCode: 'C64933',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 33,
        Name: 'Gum',
        Abbreviation: 'Y7',
        Singular: 'Gum',
        Plural: 'Gums',
        SingularOrPlural: 'Gum(s)',
        PotencyUnitCode: 'C69124',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 34,
        Name: 'Ampule',
        Abbreviation: 'AM',
        Singular: 'Ampule',
        Plural: 'Ampules',
        SingularOrPlural: 'Ampule(s)',
        PotencyUnitCode: 'C48473',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 35,
        Name: 'Applicator',
        Abbreviation: 'AP',
        Singular: 'Applicator',
        Plural: 'Applicators',
        SingularOrPlural: 'Applicator(s)',
        PotencyUnitCode: 'C62412',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 36,
        Name: 'Applicatorful',
        Abbreviation: 'AF',
        Singular: 'Applicatorful',
        Plural: 'Applicatorfuls',
        SingularOrPlural: 'Applicatorful(s)',
        PotencyUnitCode: 'C78783',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 37,
        Name: 'Bar',
        Abbreviation: 'BA',
        Singular: 'Bar',
        Plural: 'Bars',
        SingularOrPlural: 'Bar(s)',
        PotencyUnitCode: 'C48475',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 38,
        Name: 'Bead',
        Abbreviation: 'BD',
        Singular: 'Bead',
        Plural: 'Beads',
        SingularOrPlural: 'Bead(s)',
        PotencyUnitCode: 'C53495',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 39,
        Name: 'Blister',
        Abbreviation: 'BL',
        Singular: 'Blister',
        Plural: 'Blisters',
        SingularOrPlural: 'Blister(s)',
        PotencyUnitCode: 'C54564',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 40,
        Name: 'Block',
        Abbreviation: 'BK',
        Singular: 'Block',
        Plural: 'Blocks',
        SingularOrPlural: 'Block(s)',
        PotencyUnitCode: 'C53498',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 41,
        Name: 'Bolus',
        Abbreviation: 'BS',
        Singular: 'Bolus',
        Plural: 'Boluses',
        SingularOrPlural: 'Boluses',
        PotencyUnitCode: 'C48476',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 42,
        Name: 'Can',
        Abbreviation: 'CN',
        Singular: 'Can',
        Plural: 'Cans',
        SingularOrPlural: 'Can(s)',
        PotencyUnitCode: 'C48479',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 43,
        Name: 'Canister',
        Abbreviation: 'CR',
        Singular: 'Canister',
        Plural: 'Canisters',
        SingularOrPlural: 'Canister(s)',
        PotencyUnitCode: 'C62413',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 44,
        Name: 'Caplet',
        Abbreviation: 'CP',
        Singular: 'Caplet',
        Plural: 'Caplets',
        SingularOrPlural: 'Caplet(s)',
        PotencyUnitCode: 'C64696',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 45,
        Name: 'Carton',
        Abbreviation: 'CN',
        Singular: 'Carton',
        Plural: 'Cartons',
        SingularOrPlural: 'Carton(s)',
        PotencyUnitCode: 'C54702',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 46,
        Name: 'Case',
        Abbreviation: 'CA',
        Singular: 'Case',
        Plural: 'Cases',
        SingularOrPlural: 'Case(s)',
        PotencyUnitCode: 'C62414',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 47,
        Name: 'Cassette',
        Abbreviation: 'CT',
        Singular: 'Cassette',
        Plural: 'Cassettes',
        SingularOrPlural: 'Cassette(s)',
        PotencyUnitCode: 'C69093',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 48,
        Name: 'Cylinder',
        Abbreviation: 'CD',
        Singular: 'Cylinder',
        Plural: 'Cylinders',
        SingularOrPlural: 'Cylinder(s)',
        PotencyUnitCode: 'C48489',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 49,
        Name: 'Disk',
        Abbreviation: 'DK',
        Singular: 'Disk',
        Plural: 'Disks',
        SingularOrPlural: 'Disk(s)',
        PotencyUnitCode: 'C48490',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 50,
        Name: 'Dose Pack',
        Abbreviation: 'DP',
        Singular: 'Dose Pack',
        Plural: 'Dose Packs',
        SingularOrPlural: 'Dose Pack(s)',
        PotencyUnitCode: 'C62417',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 51,
        Name: 'Dual Pack',
        Abbreviation: 'DC',
        Singular: 'Dual Pack',
        Plural: 'Dual Packs',
        SingularOrPlural: 'Dual Pack(s)',
        PotencyUnitCode: 'C96265',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 52,
        Name: 'Film',
        Abbreviation: 'FM',
        Singular: 'Film',
        Plural: 'Films',
        SingularOrPlural: 'Film(s)',
        PotencyUnitCode: 'C53499',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 53,
        Name: 'Gallon',
        Abbreviation: 'GA',
        Singular: 'Gallon',
        Plural: 'Gallons',
        SingularOrPlural: 'Gallon(s)',
        PotencyUnitCode: 'C48580',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 54,
        Name: 'Implant',
        Abbreviation: 'IP',
        Singular: 'Implant',
        Plural: 'Implants',
        SingularOrPlural: 'Implant(s)',
        PotencyUnitCode: 'C48499',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 55,
        Name: 'Inhalation',
        Abbreviation: 'IH',
        Singular: 'Inhalation',
        Plural: 'Inhalations',
        SingularOrPlural: 'Inhalation(s)',
        PotencyUnitCode: 'C48501',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 56,
        Name: 'Inhaler Refill',
        Abbreviation: 'IR',
        Singular: 'Inhaler Refill',
        Plural: 'Inhaler Refills',
        SingularOrPlural: 'Inhaler Refill(s)',
        PotencyUnitCode: 'C62418',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 57,
        Name: 'Insert',
        Abbreviation: 'IN',
        Singular: 'Insert',
        Plural: 'Inserts',
        SingularOrPlural: 'Insert(s)',
        PotencyUnitCode: 'C62276',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 58,
        Name: 'Intravenous Bag',
        Abbreviation: 'IB',
        Singular: 'Intravenous Bag',
        Plural: 'Intravenous Bags',
        SingularOrPlural: 'Intravenous Bag(s)',
        PotencyUnitCode: 'C67283',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 59,
        Name: 'Millimeter',
        Abbreviation: 'MM',
        Singular: 'Millimeter',
        Plural: 'Millimeters',
        SingularOrPlural: 'Millimeter(s)',
        PotencyUnitCode: 'C28251',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 60,
        Name: 'Nebule',
        Abbreviation: 'NB',
        Singular: 'Nebule',
        Plural: 'Nebules',
        SingularOrPlural: 'Nebule(s)',
        PotencyUnitCode: 'C71204',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 61,
        Name: 'Needle Free Injection',
        Abbreviation: 'NI',
        Singular: 'Needle Free Injection',
        Plural: 'Needle Free Injections',
        SingularOrPlural: 'Needle Free Injection(s)',
        PotencyUnitCode: 'C100052',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 62,
        Name: 'Oscular System',
        Abbreviation: 'OS',
        Singular: 'Oscular System',
        Plural: 'Oscular Systems',
        SingularOrPlural: 'Oscular System(s)',
        PotencyUnitCode: 'C69086',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 63,
        Name: 'Ounce',
        Abbreviation: 'OZ',
        Singular: 'Ounce',
        Plural: 'Ounces',
        SingularOrPlural: 'Ounces',
        PotencyUnitCode: 'C48519',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 64,
        Name: 'Pad',
        Abbreviation: 'PD',
        Singular: 'Pad',
        Plural: 'Pads',
        SingularOrPlural: 'Pad(s)',
        PotencyUnitCode: 'C65032',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 65,
        Name: 'Paper',
        Abbreviation: 'PR',
        Singular: 'Paper',
        Plural: 'Papers',
        SingularOrPlural: 'Paper(s)',
        PotencyUnitCode: 'C82484',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 66,
        Name: 'Pouch',
        Abbreviation: 'PC',
        Singular: 'Pouch',
        Plural: 'Pouches',
        SingularOrPlural: 'Pouch(es)',
        PotencyUnitCode: 'C48530',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 67,
        Name: 'Pound',
        Abbreviation: 'LB',
        Singular: 'Pound',
        Plural: 'Pounds',
        SingularOrPlural: 'Pound(s)',
        PotencyUnitCode: 'C48531',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 68,
        Name: 'Puff',
        Abbreviation: 'PF',
        Singular: 'Puff',
        Plural: 'Puffs',
        SingularOrPlural: 'Puff(s)',
        PotencyUnitCode: 'C65060',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 69,
        Name: 'Quart',
        Abbreviation: 'QT',
        Singular: 'Quart',
        Plural: 'Quarts',
        SingularOrPlural: 'Quart(s)',
        PotencyUnitCode: 'C48534',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 70,
        Name: 'Ring',
        Abbreviation: 'RG',
        Singular: 'Ring',
        Plural: 'Rings',
        SingularOrPlural: 'Ring(s)',
        PotencyUnitCode: 'C62609',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 71,
        Name: 'Sachet',
        Abbreviation: 'ST',
        Singular: 'Sachet',
        Plural: 'Sachets',
        SingularOrPlural: 'Sachet(s)',
        PotencyUnitCode: 'C71324',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 72,
        Name: 'Scoopful',
        Abbreviation: 'SL',
        Singular: 'Scoopful',
        Plural: 'Scoopfuls',
        SingularOrPlural: 'Scoopful(s)',
        PotencyUnitCode: 'C48536',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 73,
        Name: 'Sponge',
        Abbreviation: 'SO',
        Singular: 'Sponge',
        Plural: 'Sponges',
        SingularOrPlural: 'Sponge(s)',
        PotencyUnitCode: 'C53502',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 74,
        Name: 'Spray',
        Abbreviation: 'SY',
        Singular: 'Spray',
        Plural: 'Sprays',
        SingularOrPlural: 'Spray(s)',
        PotencyUnitCode: 'C48537',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 75,
        Name: 'Stick',
        Abbreviation: 'SK',
        Singular: 'Stick',
        Plural: 'Sticks',
        SingularOrPlural: 'Stick(s)',
        PotencyUnitCode: 'C53503',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 76,
        Name: 'Strip',
        Abbreviation: 'SP',
        Singular: 'Strip',
        Plural: 'Strips',
        SingularOrPlural: 'Strip(s)',
        PotencyUnitCode: 'C48538',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 77,
        Name: 'Swab',
        Abbreviation: 'SB',
        Singular: 'Swab',
        Plural: 'Swabs',
        SingularOrPlural: 'Swab(s)',
        PotencyUnitCode: 'C53504',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 78,
        Name: 'Tabminder',
        Abbreviation: 'TM',
        Singular: 'Tabminder',
        Plural: 'Tabminders',
        SingularOrPlural: 'Tabminder(s)',
        PotencyUnitCode: 'C62421',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 79,
        Name: 'Tampon',
        Abbreviation: 'TP',
        Singular: 'Tampon',
        Plural: 'Tampons',
        SingularOrPlural: 'Tampon(s)',
        PotencyUnitCode: 'C48543',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 80,
        Name: 'Tray',
        Abbreviation: 'TY',
        Singular: 'Tray',
        Plural: 'Trays',
        SingularOrPlural: 'Tray(s)',
        PotencyUnitCode: 'C54704',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 81,
        Name: 'Troche',
        Abbreviation: 'TE',
        Singular: 'Troche',
        Plural: 'Troches',
        SingularOrPlural: 'Troche(s)',
        PotencyUnitCode: 'C48548',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 82,
        Name: 'Wafer',
        Abbreviation: 'WF',
        Singular: 'Wafer',
        Plural: 'Wafers',
        SingularOrPlural: 'Wafer(s)',
        PotencyUnitCode: 'C48552',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 83,
        Name: 'Pen Needle',
        Abbreviation: 'PN',
        Singular: 'Pen Needle',
        Plural: 'Pen Needles',
        SingularOrPlural: 'Pen Needle(s)',
        PotencyUnitCode: 'C120216',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 84,
        Name: 'Pre-filled Pen Syringe',
        Abbreviation: 'PPS',
        Singular: 'Pre-filled Pen Syringe',
        Plural: 'Pre-filled Pen Syringes',
        SingularOrPlural: 'Pre-filled Pen Syringe(s)',
        PotencyUnitCode: 'C97717',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 85,
        Name: 'French',
        Abbreviation: 'FR',
        Singular: 'French',
        Plural: 'Frenches',
        SingularOrPlural: 'French(es)',
        PotencyUnitCode: 'C101680',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 86,
        Name: 'Kilogram',
        Abbreviation: 'KG',
        Singular: 'Kilogram',
        Plural: 'Kilograms',
        SingularOrPlural: 'Kilogram(2)',
        PotencyUnitCode: 'C28252',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 87,
        Name: 'Milliequivalent',
        Abbreviation: 'MQ',
        Singular: 'Milliequivalent',
        Plural: 'Milliequivalents',
        SingularOrPlural: 'Milliequivalent(s)',
        PotencyUnitCode: 'C48512',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 88,
        Name: 'Pump',
        Abbreviation: 'PP',
        Singular: 'Pump',
        Plural: 'Pumps',
        SingularOrPlural: 'Pump(s)',
        PotencyUnitCode: 'C111984',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 89,
        Name: 'Device',
        Abbreviation: 'DV',
        Singular: 'Device',
        Plural: 'Devices',
        SingularOrPlural: 'Device(s)',
        PotencyUnitCode: 'C16830',
        IsActive: true,
        Result: null,
    },
    {
        DispenseUnitId: 90,
        Name: 'Lancet',
        Abbreviation: 'LN',
        Singular: 'Lancet',
        Plural: 'Lancets',
        SingularOrPlural: 'Lancet(s)',
        PotencyUnitCode: 'C120263',
        IsActive: true,
        Result: null,
    },
];
export var ObjectModels;
(function (ObjectModels) {
    ObjectModels["USER"] = "User";
    ObjectModels["VISIT"] = "Visit";
    ObjectModels["MESSAGE"] = "Message";
    ObjectModels["SETTING"] = "Setting";
    ObjectModels["VISIT_PHOTO"] = "VisitPhoto";
    ObjectModels["VISIT_PRESCRIPTION"] = "VisitPrescription";
    ObjectModels["VISIT_PHARMACY"] = "VisitPharmacy";
    ObjectModels["VIDEO_SESSION"] = "VideoSession";
    ObjectModels["PRESCRIPTION_DELIVERY"] = "PrescriptionDelivery";
    ObjectModels["WHEEL_NETWORK_CONSULT"] = "WheelNetworkConsult";
})(ObjectModels || (ObjectModels = {}));
export var PhotoSources;
(function (PhotoSources) {
    PhotoSources["PROVIDER_REQUEST"] = "provider_request";
    PhotoSources["INTAKE_TASK"] = "intake_task";
})(PhotoSources || (PhotoSources = {}));
//# sourceMappingURL=constants.js.map